import React, { useEffect, useState } from "react";
import { Code, Gamepad2, Palette, Calculator, BookOpen, TrendingUp, DollarSign, Camera, Clock } from "lucide-react";

const ProgramsSection = () => {

  const whatsappNumber = "525572269158";

  const getWhatsAppLink = (programName) => {
    const message = `Hola 👋 Me interesa el programa "${programName}" para mi hijo. ¿Me puedes dar más información?`;
    return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
  };


  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll effect for program cards
  const getProgramCardStyles = (index) => {
    const sectionStart = 1800; // Approximate start of Programs section
    const cardDelay = index * 40; // Stagger effect
    const fadeStart = sectionStart + cardDelay;
    const fadeEnd = fadeStart + 250;
    
    let opacity = 0.2;
    let transform = 'translateY(25px)';
    
    if (scrollY > fadeStart) {
      if (scrollY <= fadeEnd) {
        const fadeProgress = (scrollY - fadeStart) / (fadeEnd - fadeStart);
        opacity = 0.2 + (fadeProgress * 0.8); // Fade from 0.2 to 1
        transform = `translateY(${25 - (fadeProgress * 25)}px)`; // Move from 25px to 0px
      } else {
        opacity = 1;
        transform = 'translateY(0px)';
      }
    }
    
    return { opacity, transform };
  };

  // Scroll effect for coming soon cards
  const getComingSoonCardStyles = (index) => {
    const sectionStart = 2400; // Approximate start of Coming Soon section
    const cardDelay = index * 60; // Stagger effect
    const fadeStart = sectionStart + cardDelay;
    const fadeEnd = fadeStart + 300;
    
    let opacity = 0.15;
    let transform = 'translateY(30px)';
    
    if (scrollY > fadeStart) {
      if (scrollY <= fadeEnd) {
        const fadeProgress = (scrollY - fadeStart) / (fadeEnd - fadeStart);
        opacity = 0.15 + (fadeProgress * 0.55); // Fade from 0.15 to 0.7 (for coming soon effect)
        transform = `translateY(${30 - (fadeProgress * 30)}px)`; // Move from 30px to 0px
      } else {
        opacity = 0.7;
        transform = 'translateY(0px)';
      }
    }
    
    return { opacity, transform };
  };
  const currentPrograms = [
    {
      icon: <Code className="program-icon" />,
      title: "Exploradores de Minecraft",
      description: "Explora, construye, programa dentro del universo Minecraft mientras desarrollas creatividad, lógica, creatividad y trabajo en equipo dentro del mundo de Minecraft.",
      duration: "Favorito de los alumnos",
      level: "Edad: 6+",
      status: "available"
    },
    {
      icon: <Gamepad2 className="program-icon" />,
      title: "Roblox World Builders",
      description: "Crea tus propios mundos y juegos en Roblox. Diseña, construye y aprende las bases de programación mientras das vida a tus ideas.",
      duration: "Game Design",
      level: "Edad:12+",
      status: "available"
    },
    {
      icon: <Palette className="program-icon" />,
      title: "2D Videogames",
      description: "Diseña y programa tu primer videojuego 2D desde cero, mientras entiendes como funcionan los juegos por dentro.",
      duration: "Tu primer juego",
      level: "Edad:6+",
      status: "available"
    },
    {
      icon: <Calculator className="program-icon" />,
      title: "Misiones Matemáticas",
      description: "Matemáticas aplicadas a través de historias, retos y problemas del mundo real.",
      duration: "Lógica divertida",
      level: "Edad: 6+",
      status: "available"
    },
    {
      icon: <BookOpen className="program-icon" />,
      title: "English Quest Adventures",
      description: "Inglés con enfoque digital y misiones interactivas para desarrollar comunicación real y confianza global.",
      duration: "Inmersión total",
      level: "Edad: 9+",
      status: "available"
    }
  ];

  const comingSoonPrograms = [
    {
      icon: <TrendingUp className="program-icon" />,
      title: "Entrepreneurship",
      description: "Desarrolla ideas de negocio y aprende a pensar como un emprendedor.",
      duration: "",
      level: "",
      status: "coming-soon"
    },
    {
      icon: <DollarSign className="program-icon" />,
      title: "Finance",
      description: "Educación financiera práctica: ahorro, inversión y dinero inteligente.",
      duration: "",
      level: "",
      status: "coming-soon"
    },
    {
      icon: <Camera className="program-icon" />,
      title: "YouTuber Kids",
      description: "Creación de contenido, edición de video y comunicación digital.",
      duration: "",
      level: "" ,
      status: "coming-soon"
    }
  ];

  return (
    <section className="programs-section" id="programs">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">
            Elige la  
            <span className="title-highlight"> aventura educativa perfecta </span>
            para tu hijo
          </h2>
          <p className="section-subtitle">
            Cada programa está diseñado para desarrollar habilidades clave
            a través de proyectos emocionantes y desafiantes.
          </p>
        </div>
        
        {/* Current Programs */}
        <div className="programs-grid">
          {currentPrograms.map((program, index) => {
            const cardStyles = getProgramCardStyles(index);
            return (
              <div 
                key={index} 
                className="program-card"
                style={{
                  opacity: cardStyles.opacity,
                  transform: cardStyles.transform,
                  transition: 'opacity 0.6s ease-out, transform 0.6s ease-out'
                }}
              >
                <div className="program-header">
                  <div className="program-icon-container">
                    {program.icon}
                  </div>
                  <div className="program-meta">
                    <span className="program-duration">{program.duration}</span>
                    <span className="program-level">{program.level}</span>
                  </div>
                </div>
                
                <h3 className="program-title">{program.title}</h3>
                <p className="program-description">{program.description}</p>
                
                <a
                    href={getWhatsAppLink(program.title)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="program-cta"
                    onClick={() => window.fbq?.("track", "Contact")}>
                    <span>Quiero más información</span>
                </a>
                
                <div className="program-glow"></div>
              </div>
            );
          })}
        </div>

        {/* Coming Soon Section */}
        <div className="coming-soon-section">
          <h3 className="coming-soon-title">
            <Clock className="coming-soon-icon" />
            Próximamente
          </h3>
          <div className="coming-soon-grid">
            {comingSoonPrograms.map((program, index) => {
              const cardStyles = getComingSoonCardStyles(index);
              return (
                <div 
                  key={index} 
                  className="program-card coming-soon-card"
                  style={{
                    opacity: cardStyles.opacity,
                    transform: cardStyles.transform,
                    transition: 'opacity 0.6s ease-out, transform 0.6s ease-out'
                  }}
                >
                  <div className="coming-soon-overlay">
                    <span className="coming-soon-badge">Próximamente</span>
                  </div>
                  
                  <div className="program-header">
                    <div className="program-icon-container coming-soon-icon-container">
                      {program.icon}
                    </div>
                    <div className="program-meta">
                      <span className="program-duration">{program.duration}</span>
                      <span className="program-level">{program.level}</span>
                    </div>
                  </div>
                  
                  <h3 className="program-title">{program.title}</h3>
                  <p className="program-description">{program.description}</p>
                  
                  <button className="program-cta coming-soon-cta" disabled>
                    <span>Próximamente</span>
                  </button>
                  
                  <div className="program-glow"></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramsSection;